var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-3 col-md-6 col-xs-12"},[_c('span',{staticClass:"sub-title me-2"},[_vm._v(_vm._s(_vm.label)+":")]),_c('span',[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }